<template>
   <div role='button' class="scroll-to-top" @click="scrollToTop">
        <img src='../images/arrow-up.svg'>
    </div>
</template>

<script>
export default {
    name: 'scroll-to-top',
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
</script>

<style scoped>
  .scroll-to-top {
      position: fixed;
      bottom: 20px;
      right: 20px;
      height: 64px;
      width: 64px;
      border-radius: 32px;
      background-color: var(--global-primary-brand);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 1;
  }
</style>